import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useEffect, useState } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import { useUserParams } from "../hooks/useUserParams";

export default function Contact() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage
  } = useUserParams();
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function submitForm(event) {
    console.log("submitForm");
    event.preventDefault();
    console.log("process.env.REACT_APP_AGENT_EMAIL");
    console.log(process.env.REACT_APP_AGENT_EMAIL);

    const emailFormData = new FormData();
    emailFormData.append('data', JSON.stringify({
      recipientEmails: [getCurrentAgentEmail()],
      senderEmail: process.env.REACT_APP_AGENT_EMAIL,
      subject: "New Contact Form Message",
      content: formData.Message,
      senderName: formData.Name,
      replyTo: formData["Email Address"],
    }));

    let EmailApiUrl = process.env.REACT_APP_NODE_ENV === "production" ? "https://3.138.143.209/global/send-email" : "http://3.138.143.209/global/send-email";


    try {
      const response = await fetch(EmailApiUrl, {
        method: "POST",
        body: emailFormData,
      });

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      const res = await response.json();
      console.log("res", res);

      if (res?.message === "success") {
        console.log("Success", res);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  const seoConfig = pageSEO.contact();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full bg-logo-main pt-[150px] flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7 min-h-[70vh]">
        <div>
          <h4 className=" font-semibold text-black text-lg min-w-[20vw]">
            Questions? I'm Here To Help
          </h4>
          <form className="mt-6 flex flex-col">
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                className="form-input"
                name="Name"
                placeholder="Full Name"
                value={formData.Name}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                className="form-input"
                name="Email Address"
                placeholder="Email Address"
                value={formData["Email Address"]}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-item">
              <label className="form-label">Message*</label>
              <textarea
                className="form-input resize-none h-32"
                name="Message"
                placeholder="Your Message"
                value={formData.Message}
                onChange={handleInputChange}
              />
            </div>
            <button onClick={submitForm} className="btn-tertiary self-start px-10">
              Send
            </button>
          </form>
        </div>
        <div>
          <iframe
            src={constants.MAP}
            height="365"
            width={`${windowSize > 900 ? "500" : "300"}`}
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
       
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-2xl libre">
              {getCurrentAgentName()}
            </h2>
            <p className="italic">
              {getCurrentAgentTitle()}, {getCurrentBrokerage()}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faPhone}
                className="text-logo-third fa-lg"
              />{" "}
              {getCurrentAgentNumber()}{" "}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-logo-third fa-lg"
              />{" "}
              {getCurrentAgentEmail()}{" "}
            </p>
          </div>
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} style={{ backgroundColor: "transparent", border: "1px solid black", color: "black", padding: "10px 20px", borderRadius: "5px", cursor: "pointer" }}>
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
